import { BREAKPOINT_MED, HTML_WIDTH } from '../variables';

export default function categoryPageFunctionality() {
  addClassToCategoryPage();
}

function addClassToCategoryPage() {
  const resultCount = document.querySelector('.woocommerce-result-count');
  const categoryLoop = document.querySelector('.category-loop');
  const termDescription = document.querySelector('.term-description');
  const productList = document.querySelector('.product-list');
  const extraCatTextContainer = document.querySelector('.extra-cat-text__container');

  if (resultCount || !categoryLoop) {
    return;
  }

  categoryLoop.classList.add('category-page-category-loop');

  if (HTML_WIDTH >= BREAKPOINT_MED) // Vi vill alltid göra detta nu eftersom kunden önskar det vänsterställda utseendet.
    productList.classList.add('has-term-description');

  // Flytta term-description
  if (termDescription && HTML_WIDTH >= BREAKPOINT_MED) {
    productList.appendChild(termDescription);

    if (extraCatTextContainer) {
      productList.insertAdjacentElement('afterend', extraCatTextContainer);
    }
  }
}
